import { FlowType } from "services/user/userTypes";

export const flowTypeUrlParam = "flowType";

const FLOW_TYPE_BY_URL_PARAM: Record<string, FlowType> = {
  acn: FlowType.AcnAbn,
  abn: FlowType.Abn,
  "sole-trader": FlowType.SoleTraderAbn,
};

export const parseFlowTypeUrlParam = (value: string | undefined): FlowType | undefined => {
  if (!value) {
    return undefined;
  }

  return FLOW_TYPE_BY_URL_PARAM[value];
};
